import StickyElement from './component/StickyElement';
import StickyTarget from './component/StickyTarget';
import './Sticky.scss';
function Sticky() {
    return null;
}
Sticky.Element = StickyElement;
Sticky.Target = StickyTarget;
export default Sticky;
